var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
          _vm._v("油品看板")
        ]),
        _c("el-date-picker", {
          attrs: {
            editable: false,
            type: "date",
            "value-format": "timestamp",
            "picker-options": _vm.pickerOptionsLimit
          },
          model: {
            value: _vm.datePickerValue,
            callback: function($$v) {
              _vm.datePickerValue = $$v
            },
            expression: "datePickerValue"
          }
        }),
        _c(
          "el-tabs",
          { staticClass: "chart-wrapper", attrs: { "tab-position": "top" } },
          [
            _c(
              "el-tab-pane",
              { attrs: { lazy: true, label: "油品看板" } },
              [
                _c("slot-counter-station-bar-chart", {
                  attrs: {
                    "slots-mapping": _vm.asyncStations,
                    date: _vm.datePickerValue,
                    "total-id":
                      parseInt(_vm.userInfo.authorityId) < 30003
                        ? 999
                        : _vm.userInfo.sellerId,
                    "query-data-days": _vm.userInfo.queryDataDays,
                    "slot-counter-name": "StationOilSoldOCOSOTPCCounter"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }